import { NavigationExtras, Router } from "@angular/router";

export interface ICheckoutStep{
    stepMap:Map<number, string>
}

export const buildSteps = (steps:ICheckoutStep) =>{
    if(!steps?.stepMap){return {stepNames:undefined, initialActiveStep:undefined};}
    const sortedEntries = Array?.from(steps?.stepMap?.entries());
    const finalMap =  new Map(sortedEntries)

    return {stepNames: getStepsName(finalMap), initialActiveStep: getInitialStep(finalMap)};
}

const getInitialStep = (steps: Map<number, string>) => {
    const entriesArray = Array.from(steps.entries());

    const initialStep = entriesArray.find(([key, value]) => key === 0);

    if (initialStep) {
        const [key, value] = initialStep;
        const firstStepIndex = entriesArray.findIndex(([key, value]) => key === 0);

        return { name:value, stepIndex: firstStepIndex + 1};
    }
    return { name: undefined, stepIndex: steps.size + 1};
};

export const checkoutDefaultSteps :any = {
    first:"shared.checkout.buyerInfo",
    second:"shared.checkout.paymentDetails",
    third:"shared.checkout.overview"
}

export const defaultCheckoutStepsArray = () =>{
    const keys = Object.keys(checkoutDefaultSteps)
    let array :string[]= []
    keys.forEach(x=>{
        array.push(checkoutDefaultSteps[x])
    });
    return array;
}
export const createStepMap = (entries: [number, string][]): Map<number, string> => {
    const checkoutSteps = Array.from(entries).filter(x=>x[0] == 0  || x[0] == 1 || x[0] ==2 ).length 
    if(checkoutSteps > 0 && checkoutSteps < 3){
        throw new Error("Please include all checkout steps - you can use the defaults if there is no need for overriding some of them")
    }
    return new Map<number, string>(entries);
};

export const createStepMapFromStringArray = (steps: string[], startIndex:number): Map<number, string> => {
    let map : Map<number,string> = new Map();
    steps.forEach((step,index)=>{
        map.set(startIndex + index, step)
    });
    const checkoutSteps = Array.from(map).filter(x=>x[0] == 0  || x[0] == 1 || x[0] ==2 ).length 
    if(checkoutSteps > 0 && checkoutSteps < 3){
        throw new Error("Please include all checkout steps - you can use the defaults if there is no need for overriding some of them")
    }
    return new Map<number, string>(map);
};

export const  getPreviousSteps = (steps: Map<number, string>) =>{
    const entriesArray = Array.from(steps.entries());
    const previousSteps = entriesArray?.filter(([key, value]) => key < 0) ?? [];
    return previousSteps?.map(x=>x[1]);

}

const getStepsName = (steps: Map<number, string>) => {
    const entriesArray = Array.from(steps.entries());
    const checkouSteps = entriesArray?.filter(([key, value]) => key > 0) ?? [];

    if(checkouSteps.length == 0){
        return [...Array.from(steps?.values()) , defaultCheckoutStepsArray()]
    }

    const firstStepIndex = entriesArray?.findIndex(([key, value]) => key === 0);
    const secondStepIndex = entriesArray?.findIndex(([key, value]) => key === 1);
    const thirdStepIndex = entriesArray?.findIndex(([key, value]) => key === 2);

    if(secondStepIndex == -1){
        return [...Array.from(steps.values()) , checkoutDefaultSteps.second, checkoutDefaultSteps.third]
    }

    if(thirdStepIndex == -1){
        return  [...Array.from(steps.values()), checkoutDefaultSteps.third]
    }

    return Array.from(steps.values())
};

export const navigateToCheckout = (router:Router, route:string, stepMap:Map<number,string>)=>{
    const navigationExtras: NavigationExtras = {
        state: {
          data: stepMap
        }
      };

      return router.navigate([route], navigationExtras);
}
